import React from "react";
import { Helmet } from "react-helmet";
import '../../styles/lyrics.css';

const FutureSuperstar = () => {
  return (
    <div>
      <Helmet>
        <title>LYRICS - FUTURE SUPERSTAR</title>
      </Helmet>

      <section class="lyrics-catalog">
        <p style={{fontSize: '50px', color: '#ffffff', lineHeight: '90%', marginBottom: '60px'}}>LYRICS - FUTURE SUPERSTAR</p>
        <div class="lyrics-frames">
        <div class="lyrics">
                Yeah<br/>
                Anha!<br/>
                <br/>
                [Verse]<br/>
                Retards fuck with BR, think they won't get shot<br/>
                Bete najdeek aa&#8197;kitni&#8197;baar mujhse bulwayega<br/>
                Took&#8197;It to my heart, khudse blow&#8197;up mujhe hona hi tha<br/>
                Sunke wo my bars, all these girls screaming, oh my Gaush!<br/>
                Par nai karta notice<br/>
                Kabhi nai lose hoga focus<br/>
                Karte baate par aata nai saamne, mile toh kar dunga maun sirf (Aye)<br/>
                Kitne saalo se kar raha tha hustle mai kabhi nahi thamegi koshish (Aye), mera flow sick<br/>
                Penning all my emotions<br/>
                Show them the path likes moses (Aye)<br/>
                Mere jaise jyada mile nahi yahan par<br/>
                BKP count on m&#1077; like this shit is abacus<br/>
                Suna kehte log ko BR m&#1077; nahi lyrical rappers<br/>
                But I can spit a verse straight and I can spit that shit backwards<br/>
                You little bitch! (Aye)<br/>
                Dhudhke dikha mujhe mere jaisa scene me<br/>
                Faced my fears, bhale dikhe mera chehra nai hai<br/>
                Mai jeeta hasal se masal de jaise bella bhaiya<br/>
                Suna paisa bolta hai hamara paisa bhaira/behra bhi hai (Aanh, get it)<br/>
                Man I'mma kill 'em (Aye)<br/>
                Karte baate par aate nai saamne<br/>
                Milega kabhi na mere muqable<br/>
                Dikhe ye kabhi toh karunga khaatme<br/>
                Saal me gile jo shikwe maarke<br/>
                Zinda zameen me inko gaad ke<br/>
                Bolu mai chaude me seene ko taan ke<br/>
                Kabhi nahi aayenge, ye mere paas me<br/>
                Tere ko malum hai na (Aye)<br/>
                Laashe bichadun, mai mamuli na (Aye)<br/>
                Chahte rukana wo hamari awaaz (Aye)<br/>
                Inka mita du mai namonishaan<br/>
                Aur mere level pe na gin saku mai (Koi nahi)<br/>
                Gaush is god, insecure hounga inse kyun mai? (Kyun?)<br/>
                In the booth, waha pe lagi aag, man I send 'em fuming (Aye)<br/>
                Legend hoon mai wo kare worship, iss pen ko choome (Aye)<br/>
                Sense of humour thi sadi teri, tu hasaa mujhpe<br/>
                Kardi maine sabki hasi band jaise Kim Jong-Un mai (Rrraa)<br/>
                No narco here (Aan-han)<br/>
                You fuck with a sober mind<br/>
                No blunts and no coca lines<br/>
                Har waqt pe mai so precise<br/>
                Ye kar sakte nai overshine<br/>
                Maine luck pe nai log kamaye<br/>
                Kahun haq se mai Loka bhai<br/>
                Kya bolte? (Kya bolte bro!)<br/>
                Toh kyun mehfoos me tha?<br/>
                Bro tu utha sabki chaatkar, mai khud se upar aaya<br/>
                Nasal pehle dikhi nai should have knew just who you are<br/>
                Bitch watch, how you speak to a Future Superstar (Ahh)
            </div>
        </div>
    </section>
      

    </div>
  );
};

export default FutureSuperstar;
